'use client';

import { AuthorNickName, type AuthorNickNameProps } from '../AuthorNickName/AuthorNickName.client';
import { CreatedDate, type CreatedDateProps } from '../CreatedDate/CreatedDate.client';

export type AuthorAndCreatedWrapperProps = AuthorNickNameProps & CreatedDateProps;

export const AuthorAndCreatedWrapper = ({
  authorNickName,
  createdDate,
}: AuthorAndCreatedWrapperProps) => (
  <div className="flex flex-row gap-0.5">
    <AuthorNickName authorNickName={authorNickName} />
    |
    <CreatedDate createdDate={createdDate} />
  </div>
);
